
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useState, useCallback } from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import { mapSubstanceUse, unmapSubstanceUse } from '../../../../../lib/Proxy/SubstanceUse'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import CrudTable from '../../../../shared/CrudTable'
import { setListEmpty } from '../../../../shared/CrudTable/actions'
import FriendlyDate from '../../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../../shared/DeleteDialog/ConfirmationDeleteDialog'
import { Checkbox } from '../../../../shared/NarusMaterial'

import SubstanceForm from './form'

const mkSpec = patientId => ({
  type: 'substance',
  form: SubstanceForm,
  urls: {
    get: () => `/patients/${patientId}/lists/substances`,
    create: () => `/patients/${patientId}/lists/substances`,
    update: entry => `/patients/${patientId}/lists/substances/${entry.id}`,
    delete: entry => `/patients/${patientId}/lists/substances/${entry.id}`
  },
  mapFns: {
    toForm: unmapSubstanceUse,
    toFhir: f => mapSubstanceUse(f, patientId)
  },
  table: [
    {
      title: 'Substance',
      displayFn: x => x.type
    },
    {
      title: 'Start Date',
      displayFn: x => <FriendlyDate date={x.start} />,
      sortBy: 'start'
    },
    {
      title: 'End Date',
      displayFn: x => <FriendlyDate date={x.stop} />,
      sortBy: 'stop'
    },
    {
      title: 'Actively Using',
      displayFn: x => x.activelyUsing
    }
  ]
})

function SubstanceGrid ({
  params,
  patientId,
  isListEmpty,
  loading,
  entries,
  dispatch,
  clientName
}) {
  const ptId = params ? params.id : patientId
  const spec = mkSpec(ptId)

  let [ key, setKey ] = useState(0)

  let submitCallback = useCallback(() => {
    setKey(key => key + 1)
  }, [])

  return (
    <div className='main'>
      <Card.Card expandable>
        <Card.Header>
          <h2>Substances</h2>

          <Checkbox
            label='Patient denies any substance use'
            value={isListEmpty}
            disabled={loading || entries.length > 0}
            onChange={val => {
              dispatch(
                setListEmpty(
                  'substance',
                  `/patients/${patientId}/lists/substances`,
                  clientName,
                  val,
                  spec.urls,
                  spec.mapFns
                )
              )
            }}
          />
        </Card.Header>

        <Card.ExpandableWrapper
          style={{ padding: '0 1rem 1rem 1rem' }}
        >
          <CrudTable
            labelButton='Substance'
            labelNoEntries='Substances'
            urlFns={spec.urls}
            entryType={spec.type}
            entrySet={ptId}
            tableDefinition={spec.table}
            mapFns={spec.mapFns}
            form={spec.form}
            deleteDialog={ConfirmationDeleteDialog}
            disabled={isListEmpty}
            callbackFn={submitCallback}
          />
        </Card.ExpandableWrapper>
      </Card.Card>

      <IGAO
        key={key}
        path='substance_use'
      />
    </div>
  )
}

SubstanceGrid.contextTypes = {
  dispatch: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => {
  const patientId = redux?.globalVars?.params?.id
  const isListEmpty = _.get(
    redux,
    'crudTable.substances.additionalData.empty',
    false
  )
  const entries = _.get(redux, 'crudTable.substances.entries', [])
  const loading = _.get(redux, 'crudTable.substances.getNewEntries', true)
  const { clientName } = redux.globalVars.params
  return {
    isListEmpty,
    entries,
    loading,
    patientId,
    clientName
  }
}

export default connect(mapStateToProps)(withLegacyRouter(SubstanceGrid))
